module.exports = __webpack_public_path__ + "media/4er-System um 1 weiterzählen_201103_YB.5e5add01.mp4";